import {PlusOutlined} from '@ant-design/icons';
import {Badge, Button, Form} from 'antd';
import cn from 'classnames';
import React, {FC} from 'react';

import {validateFactorsRequired} from '../../lib/utils';
import s from '../factor-influence-info-item-modal-form.module.less';
import {FactorItem} from './factor-item';

interface IFactorsListTabProps {
    isReadOnly?: boolean;
}

export const FactorsListTab: FC<IFactorsListTabProps> = ({
    isReadOnly = false,
}) => (
        <div className={cn('form-flex', s['factors-list-container'])}>
            <Form.Item
                name="factors"
                rules={[{validator: validateFactorsRequired}]}
                noStyle
            />
            <Form.List name="factors">
                {(fields, {add, remove}) => (
                    <>
                        <Badge count={fields.length} className="add-factor-badge">
                            <Button
                                type="primary"
                                onClick={() => add()}
                                icon={<PlusOutlined />}
                                className="add-factor-button"
                                disabled={isReadOnly}
                            >
                                Добавить фактор
                            </Button>
                        </Badge>
                        
                        {fields.map((field) => (
                            <FactorItem 
                                key={field.key} 
                                field={field} 
                                onRemove={remove}
                                isReadOnly={isReadOnly}
                            />
                        ))}
                    </>
                )}
            </Form.List>
        </div>
    );


